module.exports = "query GetFlags {\n  flags {\n    name\n  }\n}\n"